import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { captureAttribution } from "@/lib/attribution";

/** Records first-touch attribution and honours the ?nostat=1 opt-out. */
const AttributionTracker = () => {
  const { search, pathname } = useLocation();
  useEffect(() => {
    captureAttribution(search, pathname);
  }, [search, pathname]);
  return null;
};

export default AttributionTracker;
